(function () {
  const initHomeBlog = () => {
    if (typeof Swiper === 'undefined') {
      return;
    }

    document.querySelectorAll('[data-home-blog]').forEach((root) => {
      if (root.dataset.homeBlogInitialized === 'true') {
        return;
      }

      const mainElement = root.querySelector('[data-home-blog-main]');
      const prevButton = root.querySelector('[data-home-blog-prev]');
      const nextButton = root.querySelector('[data-home-blog-next]');

      if (!mainElement) {
        return;
      }

      const swiperOptions = {
        speed: 450,
        spaceBetween: 16,
        slidesPerView: 2,
        grabCursor: true,
        watchOverflow: true,
        breakpoints: {
          768: {
            slidesPerView: 2,
            spaceBetween: 24,
          },
          1024: {
            slidesPerView: 3,
            spaceBetween: 24,
          },
        },
      };

      if (prevButton && nextButton) {
        swiperOptions.navigation = {
          prevEl: prevButton,
          nextEl: nextButton,
        };
      }

      new Swiper(mainElement, swiperOptions);

      root.dataset.homeBlogInitialized = 'true';
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initHomeBlog);
  } else {
    initHomeBlog();
  }

  document.addEventListener('shopify:section:load', initHomeBlog);
})();
